import CreativeVideoGallery from './CreativeVideoGallery';

export default CreativeVideoGallery;
